// export const strict = process.env.NODE_ENV !== 'production'
import * as DynamicTelephones from 'nh-dynamic-telephones'
import * as vuexLayout from 'nh-vue-layout/store/index.js'

export const state = () => ({
  ...vuexLayout.state,
  siteKey: process.env.environment.captcha.v2,
  status: false,
  loaded: {
    labels: false,
    pages: false,
    engine: false,
    header: false,
    footer: false,
    telephones: false,
    mainConfig: false,
    akamaiData: false,
    userProfile: false,
    liveLocal: false,
    liveLocalCategories: false
  },
  pageId: {
    header: null,
    footer: null,
    pages: null
  },
  error: false,
  contentPage: null,
  formData: {
    firstname: null,
    lastname: null,
    nationality: null,
    contactPhone: null,
    language: null,
    password: null,
    email: null,
    streetType: null,
    subject: null,
    faqsCategory: null,
    comments: null,
    status: null,
    type: null
  },
  mock: {
    data: {
      username: '',
      password: '',
      rememberme: true,
      captcha: { token: null, version: null }
    }
  },
  cityTax: {
    liveLocalDetail: {
      summary: null
    }
  },
  liveLocalData: null,
  cancelledLiveLocal: false,
  loadSeoOnce: false
})

export const getters = {
  ...vuexLayout.getters,
  getPageId: (state) => (type) => {
    return state.pageId[type]
  },
  mock: (state) => state.mock,
  getloadSeoOnce: (state) => () => {
    return state.loadSeoOnce
  }
}

export const mutations = {
  ...vuexLayout.mutations,
  SET_LOADED(state, { type, value }) {
    state.loaded[type] = value
    const status =
      state.loaded.labels &&
      state.loaded.pages &&
      state.loaded.engine &&
      state.loaded.header &&
      state.loaded.footer &&
      state.loaded.telephones &&
      state.loaded.mainConfig &&
      state.loaded.akamaiData &&
      state.loaded.userProfile
    this.commit('setStatus', status)
  },
  setStatus(state, value) {
    state.status = value
  },
  setError(state, value) {
    state.error = value
  },
  SET_PAGEID(state, payload) {
    state.pageId[payload.type] = payload.lang + '-' + payload.pageId
  },
  setContentPage(state, value) {
    state.contentPage = value
  },
  setLiveLocalData(state, value) {
    if (!state.liveLocalData) state.liveLocalData = value
  },
  setCancelledLiveLocal(state, value) {
    state.cancelledLiveLocal = value
  },
  setContentCityTax(state, payload) {
    const cityTaxContent = payload.data.regions.TopRegion.find((module) => module.name === 'CityTaxConfiguration').content
    if (payload.pageName === 'myBookingsLLManagement') {
      state.cityTax.liveLocalDetail.summary = cityTaxContent.liveLocalDetail
    }
  },
  setloadSeoOnce(state) {
    state.loadSeoOnce = true
  }
}

export const actions = {
  ...vuexLayout.actions,
  nuxtInit({ commit }, context) {
    // console.log('nuxtInit', context)
  },
  async getContent({ state, commit, rootGetters, dispatch }, ...payload) {
    const { type, arrayIdPage, idPage } = payload[0]
    const pageId =
      idPage || (arrayIdPage ? arrayIdPage[process.env.environmentName] : this.$modulesConfig[type].pageId[process.env.environmentName])
    const lang = this.$i18n.locale
    const content = rootGetters['pages/getContent'](lang, pageId)
    commit('SET_PAGEID', { lang, pageId, type })
    if (this.$lodash.isNil(content)) {
      await dispatch('pages/setPageContent', { pageId, type })
    } else {
      if (type === 'pages') commit('setContentPage', content)
      commit('SET_LOADED', { type, value: true })
    }
  },
  async getEngineContent({ state, commit, rootGetters, dispatch }, ...payload) {
    const { type, arrayIdPage, view, userData } = payload[0]
    const enginePageId = arrayIdPage[process.env.environmentName]
    const engineContent = rootGetters['pages/getContentEngine'](view)
    if (this.$lodash.isNil(engineContent)) {
      await dispatch('pages/setEngineContent', { pageId: enginePageId, type, view, userData })
      commit('SET_LOADED', { type, value: true })
    } else {
      commit('SET_LOADED', { type, value: true })
    }
  },
  async getAkamaiData({ commit, rootGetters }) {
    const useMock = process.env.environmentName === 'dev' || process.env.environmentName === 'preview'
    const userData = rootGetters['akamai/getUserData']
    if (this.$lodash.isEmpty(userData)) {
      const data = await this.$api.getAkamaiData(useMock)
      commit('akamai/setUserData', data)
    } else {
      window.geoIpData = userData
    }
    commit('SET_LOADED', { type: 'akamaiData', value: true })
  },
  async getTelephones({ commit }) {
    const domain = process.env.domain
    const protocol = process.env.protocol
    const url = protocol + domain
    const type = 'telephones'
    if (!sessionStorage.getItem('telephonesJSON')) {
      await DynamicTelephones.getTelephonesJSON(url).then(() => {
        this.telphonesLoaded = true
        commit('SET_LOADED', { type, value: true })
      })
    } else {
      this.telphonesLoaded = true
      commit('SET_LOADED', { type, value: true })
    }
  },
  async getUserProfile({ state, commit, rootGetters, dispatch }) {
    const type = 'userProfile'
    await dispatch('user/getUserProfile')
    commit('SET_LOADED', { type, value: true })
  },
  async getMainConfig({ commit, rootGetters }) {
    const dataMainConfig = rootGetters['pages/getMainConfig']()
    if (!dataMainConfig) {
      await this.$apiContent
        .getMainConfig()
        .then((data) => {
          commit('pages/setMainConfig', data)
          commit('SET_LOADED', { type: 'mainConfig', value: true })
        })
        .catch((e) => {
          commit('setError', { statusCode: 500, message: 'Main Config no responde' })
        })
    } else commit('SET_LOADED', { type: 'mainConfig', value: true })
  },
  setStatus({ commit }, value) {
    commit('setStatus', value)
  },
  async getLiveLocalData({ dispatch, commit, rootGetters }, view = null) {
    const id = this.$router.currentRoute.query.id
    const getterLiveLocal = !id ? null : rootGetters['livelocal/getLiveLocal'](id)

    if (!getterLiveLocal) {
      await dispatch('actionGetLiveLocalData', { tcmId: id })
    } else {
      commit('setLiveLocalData', getterLiveLocal)
      commit('SET_LOADED', { type: 'liveLocal', value: true })
    }
  },
  actionGetLiveLocalData({ dispatch, commit, rootGetters }, payload) {
    this.$apiContent.getLiveLocalData(payload.tcmId).then((data) => {
      const completeData = {
        id: payload.tcmId,
        liveLocalData: data
      }
      commit('livelocal/setLiveLocalData', completeData)
      commit('setLiveLocalData', data)
      commit('SET_LOADED', { type: 'liveLocal', value: true })
    })
  }
}
